import { apiFetch } from './client.js';
export { adminListTenants } from './auth.js';

// Modelo de planes por usuario (2026-05-27): `enterprise` ya no existe.
export type SimulatedPlan = 'start' | 'pro' | 'teams' | 'vitruvio';

/**
 * Cambia el plan de un USUARIO dentro del tenant (escribe `tenant_users.plan`).
 * Si `userId` se omite, opera sobre el propio usuario (caller staff). Solo
 * admin/owner de ECOSOFT puede. Mecanismo provisional hasta que ADLIC provea
 * el plan real por usuario.
 */
export async function adminSetTenantPlan(
  tenantId: string,
  simulatedPlan: SimulatedPlan,
  userId?: string,
): Promise<{ tenantId: string; userId: string; simulatedPlan: SimulatedPlan }> {
  return apiFetch(`/api/v1/admin/tenants/${tenantId}/plan`, {
    method: 'PATCH',
    body: userId ? { simulatedPlan, userId } : { simulatedPlan },
  });
}

export type UsagePreset = 'verde' | 'amarillo' | 'rojo' | 'tope' | 'overage' | 'reset';

export interface UsageManualOverride {
  projects_created?: number;
  chats_sent?: number;
  concepts_quoted?: number;
}

export interface UsageApplyResult {
  tenantId: string;
  userId: string;
  period: string;
  plan: string | null;
  counters: { projects_created: number; chats_sent: number; concepts_quoted: number };
}

/**
 * Panel de pruebas: aplica un preset, counters manuales o ambos a un usuario
 * del tenant (default = el propio staff). Sólo admin/owner ECOSOFT.
 */
export async function adminApplyUsage(
  tenantId: string,
  body: { preset?: UsagePreset; counters?: UsageManualOverride; plan?: SimulatedPlan; userId?: string },
): Promise<UsageApplyResult> {
  return apiFetch(`/api/v1/admin/tenants/${tenantId}/usage`, {
    method: 'POST',
    body,
  });
}

export type PackCounter = 'concepts_quoted' | 'chats_sent';

export interface PackSimResult {
  tenantId: string;
  counterType: PackCounter;
  amount: number;
  deduped: boolean;
  packId: string | null;
}

/**
 * Simula la compra de un paquete para un usuario del tenant (default = el
 * propio staff). Mismo efecto que el endpoint de ADLIC, pero protegido por
 * sesión staff. Lo usa la página de simulación ADLIC.
 */
export async function adminSimulatePack(
  tenantId: string,
  body: { counterType: PackCounter; amount: number; userId?: string },
): Promise<PackSimResult> {
  return apiFetch(`/api/v1/admin/tenants/${tenantId}/packs`, {
    method: 'POST',
    body,
  });
}
